<template>
    <div class="loading-container">
      <span>L</span>
      <div class="spinner-wrapper">
        <div class="spinner"></div>
      </div>
      <span>A</span>
      <span>D</span>
      <span>I</span>
      <span>N</span>
      <span>G</span>
    </div>
  </template>
  
  <script>
  export default {
    name: "LoadingView"
  };
  </script>
  
  <style scoped lang="scss">
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    font-family: sans-serif;
    letter-spacing: 5px;

    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);


    & > span {
      color: #FFF;
    }
  }
  
  .spinner-wrapper {
    position: relative;
    width: 1em;
    height: 1em;
    overflow: hidden;

    & > .spinner {
        position: absolute;
        width: 85%;
        height: 85%;
        border: 0.15em solid #FFF;
        border-top-color: transparent;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  </style>
  